import React from 'react';
import Header from '../Header';
import MenuControl, { MenuControlKey } from '../Header/MenuControl';
import NpiIconControl, { NpiIconControlKey } from '../Header/NpiIconControl';
import ScreenShareControl, { ScreenShareControlKey, } from '../Header/ScreenShareControl';
import ParticipantTitle from '../Header/ParticipantTitle';
import ChatControl, { ChatControlKey } from '../Header/ChatControl';
import SwitchPinControl, { SwitchPinControlKey, } from '../Header/SwitchPinControl';
const HeaderMainView = () => {
    return (<Header leftControls={[
            <MenuControl key={MenuControlKey}/>,
            <NpiIconControl key={NpiIconControlKey}/>,
            <ScreenShareControl key={ScreenShareControlKey}/>,
        ]} title={<ParticipantTitle />} rightControls={[
            <SwitchPinControl key={SwitchPinControlKey}/>,
            <ChatControl key={ChatControlKey}/>,
        ]}/>);
};
export default HeaderMainView;
